import Storage from './Storage';

/**
 * Store UserDetails
 * 
 */
class UserDetails extends Storage {
    storeName = 'user_details_';
    hasOldKey = true;

    /**
     * UserDetails constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }   

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetData(data) {
        data.data.data = (data.data.data && data.data.data.token) ? data.data.data.token : data.data.data;
        let returnData = JSON.stringify(data.data);
        return returnData;
    }

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        data.data.data = (data.data.data && data.data.data.token) ? data.data.data.token : data.data.data; 
        let returnData = JSON.stringify(data.data);
        return returnData;
    }

}

export default UserDetails;